/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import has from"../../core/has.js";const t=has("mac")?"Meta":"Control",o=new Set(["Alt","Control","Meta","Shift","Ctrl","Primary"]),r=t=>o.has(t);export{r as isSystemModifier,t as primaryKey};
